export const loginConstants = {
  GET_CURRENT_PROFILE_REQUEST: 'LOGIN/GET_CURRENT_PROFILE_REQUEST',
  GET_CURRENT_PROFILE_SUCCESS: 'LOGIN/GET_CURRENT_PROFILE_SUCCESS',
  GET_CURRENT_PROFILE_FAILURE: 'LOGIN/GET_CURRENT_PROFILE_FAILURE',

  LOGIN_REQUEST: 'LOGIN/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN/LOGIN_FAILURE',


  LOGIN_SET_PICTURE: 'LOGIN/LOGIN_SET_PICTURE',
  LOGIN_SET_PICTURE_URL: 'LOGIN/LOGIN_SET_PICTURE_URL',

  LOGOUT_REQUEST: 'LOGIN/LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'LOGIN/LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'LOGIN/LOGOUT_FAILURE',

  CHECK_EMAIL_REQUEST: 'LOGIN/CHECK_EMAIL_REQUEST',
  CHECK_EMAIL_SUCCESS: 'LOGIN/CHECK_EMAIL_SUCCESS',
  CHECK_EMAIL_FAILURE: 'LOGIN/CHECK_EMAIL_FAILURE',

  LOGIN_WITH_WP_REQUEST: 'LOGIN/LOGIN_WITH_WP_REQUEST',
  LOGIN_WITH_WP_SUCCESS: 'LOGIN/LOGIN_WITH_WP_SUCCESS',
  LOGIN_WITH_WP_FAILURE: 'LOGIN/LOGIN_WITH_WP_FAILURE',

  SET_USER_NAME: 'LOGIN/SET_USER_NAME',
}
